import React from 'react'
import { scaleDimensions, getHexColor } from '../utils'
import { OneColorLogoProps } from './LogoTypes'

export const VizioLogo: React.FC<OneColorLogoProps> = ({ height = 32, color = 'white', className }) => {
  const { width: scaledWidth, height: scaledHeight } = scaleDimensions(height, 47, 18)
  const hex = getHexColor(color)

  return (
    <svg
      viewBox="0 0 71 17"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Vizio"
      width={scaledWidth}
      height={scaledHeight}
    >
      <path
        d="M14.0298 6.35104C14.0243 6.4013 13.9705 6.60978 13.9131 6.73077L10.002 13.5509C9.77955 13.9324 9.22904 14.18 8.59881 14.18C7.96859 14.18 7.41993 13.9324 7.19565 13.5509L3.13999 6.61164C3.11774 6.55766 3.0714 6.4013 3.06955 6.35477V0.0242116H0V6.11279C0 6.97274 0.409644 7.81967 0.754412 8.37809L4.76373 15.107C5.45883 16.2741 6.92317 17 8.58584 17C9.35693 17 10.1039 16.8399 10.7471 16.5365C11.4459 16.2071 12.0039 15.7119 12.3598 15.107L16.2523 8.51955C16.686 7.775 17.0753 7.03231 17.0753 6.11279V0.0242116H14.0298V6.35104Z"
        fill={hex}
      ></path>
      <path d="M23.1921 0H20.0985V16.8567H23.1921V0Z" fill={hex}></path>
      <path
        d="M40.9088 2.72134C40.805 3.30953 40.5696 3.83258 40.2044 4.27745C39.8281 4.73721 39.3184 5.09832 38.7327 5.32355L30.3971 8.55677C29.4462 8.92346 28.701 9.34971 28.119 9.85601C27.5555 10.3456 27.1403 10.9189 26.8474 11.6076C26.5842 12.2274 26.4155 12.9385 26.321 13.8431C26.2283 14.7235 26.2154 15.7045 26.2154 16.6314V16.8585H44.0599V14.1372H29.3498C29.411 13.361 29.5592 12.7951 29.8132 12.367C30.0857 11.9091 30.499 11.5834 31.1107 11.3433L39.5427 8.11003C40.4732 7.75079 41.2239 7.31895 41.8411 6.79032C42.4324 6.28588 42.8847 5.70513 43.2276 5.0127C43.5409 4.38169 43.7578 3.6632 43.8894 2.81627C44.0043 2.08288 44.058 1.25829 44.058 0.225227V0H27.2941V2.72134H40.9088Z"
        fill={hex}
      ></path>
      <path d="M50.1786 0H47.085V16.8567H50.1786V0Z" fill={hex}></path>
      <path
        d="M69.4652 1.40162C68.4921 0.49885 67.1835 0 65.7766 0H58.4252C55.5448 0 53.2018 2.22249 53.2018 4.955V11.9035C53.2018 14.636 55.5448 16.8585 58.4252 16.8585H65.7766C67.1594 16.8585 68.4661 16.3504 69.456 15.4253C70.4513 14.4946 71 13.2623 71 11.9519V4.955C70.9981 3.58502 70.4532 2.323 69.4652 1.40162ZM56.2732 4.955C56.2732 4.40216 56.5123 3.83631 56.9312 3.4026C57.3483 2.9689 57.8933 2.72134 58.4271 2.72134H65.7784C66.3197 2.72134 66.8683 2.9689 67.2817 3.4026C67.6932 3.83444 67.9305 4.4003 67.9305 4.955V11.9035C67.9305 12.4582 67.6932 13.0259 67.2817 13.4559C66.8683 13.8896 66.3197 14.1372 65.7784 14.1372H58.4252C57.884 14.1372 57.3353 13.8896 56.922 13.4559C56.5105 13.0241 56.2732 12.4582 56.2732 11.9035V4.955Z"
        fill={hex}
      ></path>
    </svg>
  )
}
